import { useState } from "react";
import { BottomNavigation, BottomNavigationAction, Paper, Box, Button } from "@mui/material";
import { Home, Zap, Droplet, FileText, User } from "lucide-react";
import { FooterStyles } from "../../Styles/layoutStyles";
import { useTheme } from "@mui/material/styles";
import { MotionBox } from "../ui/MotionBox";
import { useNavigate, useLocation } from "react-router-dom";

export default function Footer() {
    const [active, setActive] = useState("Home");
    const navigate = useNavigate();
    const location = useLocation();

    const navItems = [
        {
            icon: <Home />, 
            label: "Home", 
            value: "Home",
            onClick: () => { navigate("/home") }
        },
        {
            icon: <Zap />, 
            label: "Pickup", 
            value: "Pickup",
            onClick: () => { navigate("/pickup") }
        },
        {
            icon: <Droplet />, 
            label: "Delivery", 
            value: "Delivery",
            onClick: () => { navigate("/delivery") }
        },
        {
            icon: <FileText />, 
            label: "Orders", 
            value: "Orders",
            onClick: () => { navigate("/main/orders") }
        },
        {
            icon: <User />, 
            label: "Account", 
            value: "Account",
            onClick: () => { navigate("/main/account") }
        },
    ];

    const theme = useTheme();
    const classes = FooterStyles(theme);

    return (
        <>
            {/* Desktop Floating Nav */}
            <MotionBox y={50} delay={1.0} sx={classes.desktopDiv}>
                <Box sx={{ display: "flex", gap: 1 }}>
                    {navItems.map((item) => (
                        <Button key={item.value}
                            onClick={() => {
                                setActive(item.value);
                                item.onClick();
                            }}
                            sx={location?.pathname?.includes(item?.label?.toLowerCase()) ? classes.active : classes.inactive}
                        >
                            <Box sx={{ lineHeight: 0 }}> {item.icon} </Box>
                            <Box sx={classes.labelText}> {item.label} </Box>
                        </Button>
                    ))}
                </Box>
            </MotionBox>

            {/* Mobile Bottom Navigation */}
            <MotionBox y={50} delay={1.0}>
                <Paper sx={classes.mobVersion} elevation={3}>
                    <BottomNavigation
                        showLabels
                        value={active}
                        onChange={(e, newValue) => setActive(newValue)}
                    >
                        {navItems.map((item) => (
                            <BottomNavigationAction
                                key={item.value}
                                label={item.label}
                                icon={item.icon}
                                value={item.value}
                                onClick={item.onClick}
                                sx={classes.mobileActive}
                            />
                        ))}
                    </BottomNavigation>
                </Paper>
            </MotionBox>
        </>
    );
}
